// extracted by mini-css-extract-plugin
export var bubble = "_1b-0";
export var container = "_1b-f";
export var contrastBorder = "_1b-g";
export var greyOut = "_1b-2";
export var initialsColor0 = "_1b-3";
export var initialsColor1 = "_1b-4";
export var initialsColor10 = "_1b-d";
export var initialsColor11 = "_1b-e";
export var initialsColor2 = "_1b-5";
export var initialsColor3 = "_1b-6";
export var initialsColor4 = "_1b-7";
export var initialsColor5 = "_1b-8";
export var initialsColor6 = "_1b-9";
export var initialsColor7 = "_1b-a";
export var initialsColor8 = "_1b-b";
export var initialsColor9 = "_1b-c";
export var initialsWrapper = "_1b-1";
export var large = "_1b-l";
export var medium = "_1b-k";
export var mediumSmall = "_1b-j";
export var mediumSmallMedium = "_1b-o";
export var micro = "_1b-h";
export var small = "_1b-i";
export var tiny = "_1b-n";
export var xTiny = "_1b-m";